import spinnerImg from '../../assets/images/loader.gif';

function LoadingScreenInner({ zIndex = 9999 }: { zIndex?: number }) {
  return (
    <div className="pageloader" style={{ zIndex: zIndex }}>
      <img src={spinnerImg} alt="page loader" className="w-20" />
    </div>
  );
}
export const LoadingScreen = LoadingScreenInner;
